<h2 mat-dialog-title>
  <span class="eyebrow">Match Transactions</span>
  <div class="title-row">
    <span>Select a date window to browse candidates</span>
  </div>
  <div class="receipt-context" *ngIf="receiptContext">
    <div class="context-item">
      <label>Receipt date</label>
      <span>{{ receiptContext.date | date:'yyyy-MM-dd' }}</span>
    </div>
    <div class="context-item">
      <label>Description</label>
      <span>{{ receiptContext.description || '-' }}</span>
    </div>
    <button
      type="button"
      class="context-item amount-card"
      (click)="findAmountMatches()"
      [disabled]="isLoading || receiptAmountCents === null">
      <label>Amount</label>
      <span>{{ (receiptContext.amount || 0) * 100 | human }}</span>
      <small>Click to search all matching amounts</small>
    </button>
  </div>
</h2>

<mat-dialog-content>
  <div class="dialog-workbench">
    <section class="transaction-panel">
      <div class="filters">
        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Start date</mat-label>
          <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>End date</mat-label>
          <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <span class="spacer"></span>

        <button mat-stroked-button color="primary" (click)="applyRange()" [disabled]="isLoading">
          <mat-icon>search</mat-icon>
          Preview range
        </button>
        <button mat-button color="primary" (click)="expandDayRangeByOne()" [disabled]="isLoading">
          <mat-icon>unfold_more</mat-icon>
          Expand +/- 1 day
        </button>
      </div>

      <div class="quick-find">
        <span class="label">Quick find</span>
        <button mat-stroked-button color="primary" (click)="findAmountMatchesOneMonth()" [disabled]="isLoading || receiptAmountCents === null">
          <mat-icon>find_in_page</mat-icon>
          Find amount matches (+/- 1 month)
        </button>
      </div>

      <div class="table-wrap">
        <div *ngIf="isLoading" class="loading">Loading transactions...</div>
        <div *ngIf="hasSearched && !isLoading && dataSource.data.length === 0" class="loading empty">
          No transactions found for this search.
        </div>
        <table *ngIf="!isLoading && dataSource.data.length > 0" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element">{{ element.date | date:'yyyy-MM-dd' }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">{{ element.description }}</td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let element">{{ human(element.amount) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
            (click)="matchTransaction(row, i)"
            [class.amount-match]="isAmountMatch(row)"
            [class.selected]="isSelected(row, i)">
          </tr>
        </table>
      </div>
    </section>

    <aside class="receipt-preview-panel">
      <div class="preview-header">
        <div>
          <p class="eyebrow">Receipt preview</p>
          <h3>{{ receipt?.file?.filename || receiptContext?.description || 'Receipt' }}</h3>
        </div>
        <a *ngIf="receipt?.file" [href]="receiptsService.getReceiptURL(receipt)" target="_blank" mat-stroked-button>
          <mat-icon>open_in_new</mat-icon>
          Open
        </a>
      </div>

      <div class="preview-meta" *ngIf="receiptContext">
        <span>{{ receiptContext.date ? (receiptContext.date | date:'dd MMM yyyy') : 'Date unknown' }}</span>
        <span>{{ (receiptContext.amount || 0) * 100 | human }}</span>
      </div>

      <div class="viewer" *ngIf="receipt?.file; else missingReceiptPreview">
        <ng-container [ngSwitch]="receipt.file?.type">
          <img *ngSwitchCase="MediaType.IMAGE" [src]="receiptsService.getReceiptURL(receipt)" class="image-viewer">
          <pdf-viewer
            *ngSwitchCase="MediaType.PDF"
            [src]="receiptsService.getReceiptURL(receipt)"
            [render-text]="true"
            [fit-to-page]="true"
            [original-size]="false"
            style="display: block;height:100%;"
            class="pdf-viewer"></pdf-viewer>
          <div *ngSwitchDefault class="unsupported">Unsupported or unknown receipt type.</div>
        </ng-container>
      </div>
      <ng-template #missingReceiptPreview>
        <div class="empty-preview">
          <p>No receipt file is available for preview.</p>
        </div>
      </ng-template>
    </aside>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="useSelected()" [disabled]="!selectedTransaction">Use Selected</button>
</mat-dialog-actions>
